export default {
    audioBook: {}
};
